/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Hint_Models_UnrecognisedInputs */



/**
* | output |
* | --- |
* | "The response is not a model list. Check that the URL points to an OpenAI-compatible API." |
*
* @param {Private_Models_Hint_Models_UnrecognisedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_hint_models_unrecognised = /** @type {((inputs?: Private_Models_Hint_Models_UnrecognisedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Hint_Models_UnrecognisedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Antwort ist keine Modellliste. Prüfen Sie, ob die URL auf eine OpenAI-kompatible API zeigt.")
	return /** @type {LocalizedString} */ ("The response is not a model list. Check that the URL points to an OpenAI-compatible API.")
});